import {gsap} from "gsap";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import {SplitText} from "gsap/SplitText";


window.addEventListener("DOMContentLoaded", () => {
    let buttons = document.querySelectorAll(".navButtons")


    buttons.forEach(button => {
        let tl = gsap.timeline({paused: true,});
        let span = button.querySelector(".span");

        tl.to(span, {duration: 0.2, yPercent: 150, ease: "power2.in"});
        tl.set(span, {yPercent: -150});
        tl.to(span, {duration: 0.2, yPercent: 0});

        button.addEventListener("mouseenter", () => tl.play(0));

        gsap.registerPlugin(ScrollToPlugin);

        const scrollTarget = button.getAttribute("data-target");
        const targetElement = document.querySelector(scrollTarget)
        if (targetElement) {

            button.addEventListener("click", () => {
                gsap.to(window, {
                    duration: 1,
                    scrollTo: {
                        y: targetElement,
                    },
                    ease: "power2.inOut"
                });
            });
        }
    });
});
